import { API_ROOT_URL, onlyDefinedSearchParameters, SearchParameters } from '..'
import {
  ParkingEventDetailsDTO,
  ParkingEventSessionStatus,
  ParkingEventsResponseDTO,
  UpdatePriceDTO,
} from './dto'

import { PaginationAndSortingValues } from '../../components/moovyPagination'
import { client } from '../moovyAxiosClient'

const BASE_URL = `${API_ROOT_URL}/parking-events`

const getOngoingParkingEvents = (params: {
  paginationAndSorting: PaginationAndSortingValues
  searchParameters?: SearchParameters
}) =>
  getParkingEvents({
    sessionStatus: 'ONGOING',
    ...params,
  })

const getEndedParkingEvents = (params: {
  paginationAndSorting: PaginationAndSortingValues
  searchParameters?: SearchParameters
}) =>
  getParkingEvents({
    sessionStatus: 'ENDED',
    ...params,
  })

const getParkingEvents = (params: {
  sessionStatus: ParkingEventSessionStatus
  paginationAndSorting: PaginationAndSortingValues
  searchParameters?: SearchParameters
}) => {
  return client.get<ParkingEventsResponseDTO>(BASE_URL, {
    params: {
      sessionStatus: params.sessionStatus,
      ...params.paginationAndSorting,
      ...onlyDefinedSearchParameters(params.searchParameters),
    },
  })
}

const getParkingEventDetails = (id: string) => {
  return client.get<ParkingEventDetailsDTO>(`${BASE_URL}/${id}`)
}

const updatePrice = (parameters: { id: string; values: UpdatePriceDTO }) => {
  return client.post<ParkingEventDetailsDTO>(
    `${BASE_URL}/${parameters.id}/price`,
    parameters.values,
  )
}

export const ParkingEventsApi = {
  getOngoingParkingEvents,
  getEndedParkingEvents,
  getParkingEventDetails,
  updatePrice,
}
